import { makeQuery } from 'shared/utilities';
import { ITaskModel } from "shared/models/TaskTracker";

type RequestType = ITaskModel;

type ResponseType = {
    item: ITaskModel
};

export const tasksProposeQuery = async function (request: RequestType) {
    return await makeQuery<ResponseType>('/tasks/propose', {
        prefix: 'task-tracker',
        json: request
    });
}
